export const fixture = {
  environments: {
    mature: {
      client: "Northstar Industrial Systems",
      title: "Mature Enterprise Content Environment",
      stats: [
        ["Connection", "Read-only"],
        ["Documents in scope", "1,842"],
        ["Metadata quality", "High"],
        ["Version authority", "Established"],
        ["Document ownership", "94% established"]
      ],
      statement:
        "The existing content-management platform remains the system of record. CERTEVON Intelligence™ adds operational and change intelligence."
    },
    fragmented: {
      client: "Piedmont Precision Components",
      title: "Fragmented Knowledge Environment",
      discovery: [
        ["Files discovered", "2,437"],
        ["Requirement documents", "143"],
        ["Policies", "41"],
        ["Procedures", "187"],
        ["Work instructions", "426"],
        ["Forms/templates", "211"],
        ["Training/job aids", "76"]
      ],
      issues: [
        "Potential duplicates",
        "Unclear versions",
        "Potentially superseded documents",
        "Missing owners",
        "Broken references",
        "Inconsistent templates"
      ],
      recommendations: [
        ["Classify QP-17 as Customer Quality Incident procedure", "High confidence"],
        ["Propose F-18 v2 as current form candidate", "Needs owner confirmation"],
        ["Standardize training job aids to operations template", "Recommended"],
        ["Flag WI-22 duplicate cluster for review", "Ambiguous"]
      ]
    }
  },
  graph: {
    nodes: [
      { id: "REQ-48", type: "Requirement", name: "Critical incident reporting", owner: "Regulatory Affairs", version: "v2", source: "Customer requirement register", x: 50, y: 36 },
      { id: "PROC-CQI", type: "Process", name: "Customer Quality Incident Management", owner: "Quality Operations", version: "Active", source: "Process map", x: 27, y: 31 },
      { id: "QP-17", type: "Procedure", name: "Customer Incident Escalation", owner: "Customer Quality", version: "v4", source: "OpenText controlled doc", x: 27, y: 57 },
      { id: "CTRL-31", type: "Control", name: "Escalation SLA control", owner: "Compliance", version: "v3", source: "Control library", x: 51, y: 64 },
      { id: "F-18", type: "Form", name: "Initial Incident Notification", owner: "Quality Systems", version: "v2", source: "Forms catalog", x: 72, y: 56 },
      { id: "CRM", type: "System dependency", name: "CRM Escalation Timer", owner: "Enterprise Apps", version: "48h config", source: "CRM configuration", x: 74, y: 31 },
      { id: "ROLE-QE", type: "Role", name: "Quality Engineer", owner: "Plant Quality", version: "Role profile", source: "Role taxonomy", x: 39, y: 82 },
      { id: "T-22", type: "Training", name: "Critical Incident Reporting", owner: "Learning", version: "v3", source: "LMS catalog", x: 62, y: 84 },
      { id: "JA-04", type: "Job aid", name: "Containment checklist", owner: "Operational Excellence", version: "v1", source: "Enablement library", x: 84, y: 79 }
    ],
    links: [
      ["REQ-48", "PROC-CQI", "Requirement drives process obligation"],
      ["PROC-CQI", "QP-17", "Procedure defines execution steps for process"],
      ["QP-17", "CTRL-31", "Control verifies escalation timing"],
      ["QP-17", "F-18", "Procedure requires notification form"],
      ["CTRL-31", "CRM", "Timer evidence comes from CRM workflow"],
      ["QP-17", "ROLE-QE", "Role performs first-line incident assessment"],
      ["ROLE-QE", "T-22", "Training certifies required way of working"],
      ["T-22", "JA-04", "Job aid supports training transfer"],
      ["F-18", "JA-04", "Containment fields map to checklist prompts"]
    ]
  },
  change: {
    customer: "Northstar Motors",
    published: "September 15",
    effective: "January 1",
    current: "Critical quality incidents must be reported within 48 hours.",
    future: "Critical quality incidents must be reported within 24 hours and the initial notification must include an initial containment plan."
  },
  staged: [
    ["Notification requirement", "48-hour notification", "24-hour notification + containment", "Staged, not active"],
    ["Procedure", "QP-17 v4", "QP-17 revision required", "Draft needed"],
    ["Control", "48-hour escalation control", "Control revision required", "Owner review"],
    ["Form", "F-18 without containment field", "F-18 containment field required", "Design needed"],
    ["System", "CRM timer 48 hours", "CRM configuration review", "IT validation"],
    ["Training", "T-22 training based on 48 hours", "Training revision required", "Enablement"]
  ],
  impacts: [
    ["Customer Quality Incident Management process", "Requirement changes the time-critical execution path", "Requirement text + process dependency", "High", "96%", "Quality Operations"],
    ["QP-17", "Procedure contains 48-hour notification steps", "Procedure section 4.2", "High", "98%", "Customer Quality"],
    ["CTRL-31", "Escalation control measures 48-hour performance", "Control objective + SLA", "High", "94%", "Compliance"],
    ["F-18", "Initial notification lacks containment-plan field", "Form field inventory", "Medium", "89%", "Quality Systems"],
    ["CRM Escalation Timer", "Workflow timer currently set to 48 hours", "System configuration extract", "High", "91%", "Enterprise Apps"]
  ],
  people: [
    ["Quality Engineer", "Opens notification within 48 hours", "Open within 24 hours and add initial containment", "High", "126", "Performs intake and initial assessment"],
    ["Customer Quality Manager", "Reviews escalations against 48-hour SLA", "Reviews 24-hour SLA and containment completeness", "High", "18", "Owns customer-facing escalation quality"],
    ["Plant Quality Manager", "Monitors late 48-hour reports", "Monitors readiness for 24-hour reporting", "Medium", "32", "Accountable for site quality response"],
    ["Production Supervisor", "Provides facts after quality request", "Provides containment details earlier", "Medium", "214", "Supplies production context for containment"]
  ],
  enablement: ["T-22 training revision", "JA-04 job aid revision", "F-18 form revision", "Manager communication recommendation"],
  drafts: [
    ["QP-17 v5", "Redline changes 48 hours to 24 hours and adds containment-plan section before initial notification approval.", "Standardized draft preserves approved incident taxonomy and adds a containment decision table."],
    ["F-18 v3", "Redline adds initial containment plan, responsible owner, and target completion fields.", "Standardized draft aligns labels, field order, and evidence prompts with controlled form template."],
    ["T-22 v4", "Redline updates escalation scenario, timing checks, and completion criteria.", "Standardized draft adds a practice exercise for containment-plan completeness."],
    ["JA-04 v2", "Redline adds a first-24-hours checklist and containment examples.", "Standardized draft maps each prompt to QP-17 v5 and F-18 v3 fields."]
  ],
  actions: [
    ["Customer Quality", "Approve QP-17 v5 staged procedure", "Nov 15", "Controlled document approval", "In progress"],
    ["Quality Systems", "Publish F-18 v3 form package", "Nov 20", "Form validation record", "In progress"],
    ["Enterprise Apps", "Verify CRM 24-hour timer", "Dec 1", "Configuration evidence", "Blocked"],
    ["Learning", "Assign and track T-22 v4", "Dec 10", "LMS completion extract", "At risk"],
    ["Plant Quality", "Confirm supervisor job aid adoption", "Dec 18", "Manager attestation", "Not started"]
  ],
  readiness: {
    atRisk: [
      ["Operational Readiness", 83, "CRM configuration not verified"],
      ["People Readiness", 64, "Required Quality Engineer training incomplete"],
      ["Enablement Readiness", 71, "Job aid acknowledgement still open"],
      ["Overall", 73, "AT RISK"]
    ],
    ready: [
      ["Operational Readiness", 100, "CRM configuration verified"],
      ["People Readiness", 100, "Required training complete"],
      ["Enablement Readiness", 100, "All job aids acknowledged"],
      ["Overall", 100, "READY FOR ACTIVATION"]
    ]
  },
  executive: {
    health: [["Authoritative", "96%"], ["Relationship coverage", "91%"], ["Unresolved issues", "7"]],
    portfolio: [["On Track", "14"], ["At Risk", "3"], ["Awaiting Review", "5"]],
    impact: [["Processes affected", "1"], ["Roles affected", "4"], ["Employee population represented", "390"], ["Training assets", "2"], ["System dependencies", "1"]],
    dates: ["Northstar Motors incident reporting - Jan 1", "Supplier PPAP evidence refresh - Feb 15", "Calibration record retention - Mar 1"]
  }
} as const;
